import {
  Alignment,
  Button,
  Classes,
  FormGroup,
  H5,
  InputGroup,
  Popover,
  Position,
  Tooltip,
} from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IIcmsClassificacao } from "../../../model";
import { AppStore } from "../../../stores/AppStore";
import { LookupStore } from "../../../stores/LookupStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { filterIcmsClassificacao, IcmsClassificacaoSelect, renderIcmsClassificacao } from "../../utils/IcmsClassificacaoSelect";
import { PagerResultados } from "../../utils/PagerResultados";
import DetalhamentoCteTable from "./detalhamento_cte_table";

var debounce = require('lodash.debounce');

interface Props {
  handleContestarLote: () => void;
}

interface State {
  handleContestarLote: () => void;
}

@observer
export default class DetalhamentoCte extends React.Component<Props, State> {

  obs = observable({
    fetchOptions: {} as any
  })

  constructor(props) {
    super(props);
    ResultadoStore.obs.results = [];
    ResultadoStore.obs.summary = [];

    this.state = {
      handleContestarLote: props.handleContestarLote,
    };

    this.obs.fetchOptions = debounce(this.handleQuery.bind(this), 800);

  }

  async handleQuery() {

    await ResultadoStore.query();

  }

  async handlePageChange(pager) {

    ResultadoStore.obs.current_page = pager

    this.handleQuery()

  }

  handleContestarTodos() {
    ResultadoStore.selectAllContestarLoteCTE();
    ResultadoStore.obs.contestar_todos = true;
    this.state.handleContestarLote();
  }

  async handleChangeClass(item) {

    ResultadoStore.setIcmsClassFilter(item);

    ResultadoStore.obs.current_page = 1

    this.handleQuery()

  }

  async handleQueryFilters(e) {

    ResultadoStore.obs.current_page = 1

    this.obs.fetchOptions()

  }

  render() {
    let results = ResultadoStore.obs.results;

    let classItems = LookupStore.obs.icms_classificacoes.concat(
      [{ codigo_receita: "0000", nome: "Sem classificação (itens não calculados)" }],
      [{ codigo_receita: "00000", nome: "Todas" }]
    );

    let selectedItemCaption = ResultadoStore.selectedCount == 1 ? "item" : "itens";

    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    return (
      <>
        <MDBCol>
          <MDBRow>

            <MDBCol>
              <MDBRow>
                <FormGroup label="Filtro de Classificação" style={{ width: "60%" }}>
                  <IcmsClassificacaoSelect
                    items={classItems}
                    itemRenderer={renderIcmsClassificacao}
                    itemPredicate={filterIcmsClassificacao}
                    onItemSelect={(item: IIcmsClassificacao) => this.handleChangeClass(item)}
                  >
                    <Button
                      text={
                        (ResultadoStore.obs.icmsClassFilter &&
                          ResultadoStore.obs.icmsClassFilter.nome) ||
                        "Selecionar classificação..."
                      }
                      rightIcon="double-caret-vertical"
                      alignText={Alignment.LEFT}
                      className="IcmsClassificacao"
                    />
                  </IcmsClassificacaoSelect>
                </FormGroup>

                &nbsp;

                {AppStore.obs1.usuario &&
                  <div style={{ width: "30%" }}>
                    <Tooltip
                      content={`Contestar ${ResultadoStore.obs.contestar_todos ? "todos" : ResultadoStore.selectedCount} ${selectedItemCaption}`}
                      disabled={ResultadoStore.selectedCount == 0}
                    >
                      <Button
                        className="btncontestarWidth mt25"
                        disabled={
                          ResultadoStore.selectedCount == 0 ||
                          niveis_acesso.indexOf("c2") == -1
                        }
                        icon="issue"
                        onClick={this.state.handleContestarLote}
                      >
                        Contestar Selecionados
                      </Button>
                    </Tooltip>
                  </div>
                }
              </MDBRow>
            </MDBCol>

            <MDBCol>
              <MDBRow style={{ float: "right" }}>

                <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position={Position.LEFT_BOTTOM}>
                  <MDBBtn className="btnDefault btnBuscarNfe mt25" disabled={niveis_acesso.indexOf("c2") == -1}>Selecionar Todos</MDBBtn>
                  <div>
                    <H5>Confirmar Seleção</H5>
                    <p>Tem certeza que deseja selecionar todos os itens?</p>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                      <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }} onClick={() => ResultadoStore.resetContestarItems()}>Não</Button>
                      <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleContestarTodos()}>Sim</Button>
                    </div>
                  </div>
                </Popover>
              </MDBRow>
            </MDBCol>

          </MDBRow>
        </MDBCol>

        <MDBRow>
          <MDBCol md="8">
            <thead>
              <tr>

                <th style={{ width: "5%" }}>
                  <FormGroup label="Descrição">
                    <InputGroup placeholder="Filtrar uma descrição" value={ResultadoStore.obs.filters.filterDescricao} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters.filterDescricao = e.target.value)} />
                  </FormGroup>
                </th>

                <th style={{ width: "5%" }}>
                  <FormGroup label="Cfop">
                    <InputGroup placeholder="Filtrar um Cfop" value={ResultadoStore.obs.filters.filterCfop} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters.filterCfop = e.target.value)} />
                  </FormGroup>
                </th>

                <th style={{ width: "5%" }}>
                  <FormGroup label="Chave">
                    <InputGroup placeholder="Filtrar uma Chave" value={ResultadoStore.obs.filters.filterChave} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters.filterChave = e.target.value)} />
                  </FormGroup>
                </th>

              </tr>
            </thead>
          </MDBCol>
        </MDBRow>

        <DetalhamentoCteTable
          modelo={ResultadoStore.obs.modelo}
          entrada_saida={ResultadoStore.obs.tipo}
          items={results}
        />

        <div style={{ marginTop: 5, marginBottom: 200 }}>
          <div style={{ flexGrow: 1, lineHeight: "30px" }}></div>
          <PagerResultados
            currentPage={ResultadoStore.obs.current_page}
            totalCount={ResultadoStore.obs.itemsCount}
            onPageChange={pager => this.handlePageChange(pager)}
            pageSize={15}
          />
        </div>

      </>
    );
  }
}
